/**
 * O que a Ruth consegue fazer nesta instalação, e o que ainda não.
 *
 * **Aqui não se cola chave nenhuma.** As credenciais são da operação, não da
 * mãe: uma só chave atende todas as casas e é ela que gera a fatura. Um campo
 * aqui deixaria a Daniela poder ler ou trocar a chave que o Carlos paga, e
 * guardaria segredo de operação no mesmo banco que guarda receita de criança.
 * As chaves entram no `.env` do servidor — a regra está no CLAUDE.md.
 *
 * O que esta lista responde é a pergunta da mãe: por que o microfone não
 * funciona hoje. Do lado do operador, `python -m app.cli integracoes` diz qual
 * variável falta.
 */

import { useEffect, useState } from 'react'

import { api, type Integracao } from '../api'
import { Icone } from './Icone'
import '../estilos/integracoes.css'

export function Integracoes() {
  const [itens, setItens] = useState<Integracao[] | null>(null)

  useEffect(() => {
    api
      .integracoes()
      .then((r) => setItens(r.integracoes))
      .catch(() => setItens([]))
  }, [])

  if (itens === null || itens.length === 0) return null

  return (
    <section className="integra">
      <h2 className="eyebrow">O que eu consigo fazer</h2>

      {itens.map((item) => (
        <div key={item.chave} className={`integra__linha ${item.ligada ? '' : 'integra__falta'}`}>
          <span className="integra__marca">
            {item.ligada ? <Icone nome="check" tamanho={16} /> : <span aria-hidden>—</span>}
          </span>
          <span className="integra__texto">
            <span className="integra__nome">{item.nome}</span>
            {!item.ligada && <span className="integra__aviso">{item.sem_ela}</span>}
          </span>
        </div>
      ))}
    </section>
  )
}
